module.exports = __webpack_public_path__ + "img/share.70afe731.svg";